import { type ReactElement } from 'react';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { Slider } from '@hivebrite/design-system/Slider';

import type { FrameChild } from 'hb-builder/components/RenderComponents/page/block/Strips/types/items';
import { perPageBreakpoints } from 'hb-builder/components/UIComponents/page/dynamic/Slider/utils/breakpoints';
import type { DocumentItem } from 'hb-react/backoffice/types/builder/builderDocument';

interface StripsSliderUIProps {
  renderItem: (item: FrameChild) => ReactElement;
  stripSlider: DocumentItem;
}

const StripsSliderUI = ({ renderItem, stripSlider }: StripsSliderUIProps) => {
  const stripSliderItems = stripSlider.children as FrameChild[];

  // TODO: migration, add attribute `numberOfItems` for all templates
  const numberOfItemsStr =
    stripSlider.template === 'StripsTemplateWithPlainImages'
      ? '3'
      : stripSlider.attributes?.numberOfItems || '4';

  const numberOfItems = parseInt(numberOfItemsStr, 10);

  if (!stripSliderItems) {
    return null;
  }

  return (
    <SliderWrapper dataTestId="strips-slider">
      <Slider
        items={stripSliderItems}
        perPageBreakpoints={perPageBreakpoints({
          numberOfItems,
        })}
        loading={false}
        renderItemComponent={renderItem}
        renderLoadingItemComponent={() => <div />}
        total={stripSliderItems.length}
      />
    </SliderWrapper>
  );
};

export default StripsSliderUI;

const SliderWrapper = styled(Box).attrs(() => ({
  my: 6,
  width: '100%',
}))`
  .slider-container {
    width: 100%;
  }
`;
